import { TicketSummaryDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { selectTicket, TicketSelection } from 'pos/modules/helpers/ticket-selection';

export async function selectOpenTicket(tickets: TicketSummaryDTO[]): Promise<Result<TicketSelection>> {

	if (tickets.length === 0)
		return Result.ok({ select: 'new' });

	if (tickets.length === 1)
		return Result.ok({ select: 'existing', ticket: tickets[0] });

	return selectTicket({ tickets });
}